import React from "react";
import { Modal } from "react-bootstrap";
import Lottie from "lottie-react";
import animationAccept from "../../../../lottie/accept-lottie/Accept_Lottie.json";
const Subscription_Plan_Modal = ({
  showAddsubscription,
  handleAddSubscriptionClose,
}) => {
  return (
    <Modal
      show={showAddsubscription}
      onHide={handleAddSubscriptionClose}
      centered
      className="add-money-success-modal suscription-plan-modal"
    >
      <Modal.Body className="p-0">
        <div className="modal-card-container">
          <div className="success-circle-icon">
            <Lottie animationData={animationAccept} loop={true} />
          </div>
          <div className="success-content">
            <h5 className="success-text">Subscription added successfully</h5>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Subscription_Plan_Modal;
